export default "__VITE_ASSET__BMcqdRNa__"